export default {
  data() {
    return {
      triggerDelay: 200,
      clicks: 0,
      timer: null,
    };
  },
  methods: {
    clickHandler(one, dbl) {
      this.clicks++;
      if (this.clicks === 1) {
        this.timer = setTimeout(() => {
          one();
          this.clicks = 0;
        }, this.triggerDelay);
      } else {
        clearTimeout(this.timer);
        dbl();
        this.clicks = 0;
      }
    },
  },
};
